import { render, staticRenderFns } from "./CopTemplateSearchBarComponent.vue?vue&type=template&id=61248982"
import script from "./CopTemplateSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./CopTemplateSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./CopTemplateSearchBarComponent.vue?vue&type=style&index=0&id=61248982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports